import { ApiVersion } from '../models';

export const isValidIdentifier = (identifier: string) => !!identifier;

export const isValidApiConfig = ({
    apiVersion,
    identifier,
}: {
    apiVersion: ApiVersion;
    identifier: string;
}): boolean => {
    return isValidIdentifier(identifier) && isValidApiVersion(apiVersion);
};

export const isValidApiVersion = (apiVersion: ApiVersion): boolean => {
    return apiVersion >= 5;
};
